import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';
import { StylistsPage } from '../stylists/stylists.page';
import { CalendarComponentOptions } from "ion2-calendar";
import { LoginModalPage } from '../login-modal/login-modal.page';

@Component({
  selector: 'app-add-booking',
  templateUrl: './add-booking.page.html',
  styleUrls: ['./add-booking.page.scss'],
})
export class AddBookingPage implements OnInit {
  services=[]
  stylist_list=[]
  book_time = 'now';
  service: any;
  value: any;
  stylist: any;
  timing: any;
  schedule_time: any;
  timings: any = [];
  category : any;
  categories=[]
  selectedCategory : any;
  service_id : any;
  serviceTemp : boolean = true;
  stylistTemp : boolean = false;
  timeTemp : boolean = false;
  paymentTemp : boolean = false;
  cardNumber : any;
  cvv : any;
  expiryMonth : any;
  expiryYear : any;
  paymentDetail : any = [];
  tax : any;
  total : any = 0;
  percent_tip_vlaue : any;
  tip_type: any ;
  tip : any = 0;
  notes : any;
  mygifts  = [];
  // giftcardId='0';
  giftCard : any;
  gift_card_amount = 0;
  gift_array : any;
  amountArray : any =[];
  giftcardId : any;
  gitfcardAmount : any;
  ccFee:any = 0;
  subTotal : any = 0;
  isDataLoaded=false;
  optionsCal: CalendarComponentOptions = {
    from: new Date(),
    color: 'primary',
    pickMode: 'single'
  };
  date: string;
  type: 'string';
  showCalender: boolean=false;
  showTimings: boolean=false;
  paymentMethods: any[];
  paymentfrom='addNew'
  constructor(
    public server:UserApiService,
    public globals:GlobalVariable,
    private modalController:ModalController,
    public alertCtrl:AlertController,
    private loadingCtrl:LoadingController,
    private navCtrl:NavController,

  ) { 
    
  }

  ngOnInit() {
  }
  ionViewWillEnter(){
    this.getSavedCards()
    this.schedule_time = this.formatDate();
    console.log(this.schedule_time)
    this.get_services_categories();
  }
  formatDate() {
    console.log('in data func ')
    var d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  onDateChange(event) {
    console.log(event)
    this.schedule_time = event.format('YYYY-MM-DD');
    this.setStylist();
  }
  get_services_categories() {
  

    let response = this.server.get_services_categories();
    response.subscribe(data => {
      console.log(data)
      if (data.status == true) {
        this.categories = data.data;
        this.category = this.categories[0];
        this.selectedCategory = this.category.name;
        this.get_services();
      }
   

    }, error => {
     
      this.globals.presentToast("Something went wrong check your internet connection.")
    });
  }

  get_services() {
  
this.isDataLoaded=false;
    let response = this.server.get_services(this.category.id);
    response.subscribe(data => {
      this.isDataLoaded=true;
      console.log(data)
      if (data.status == true) {
        this.services = data.services;
        // this.setService();
      }
     

    }, error => {
    
      this.globals.presentToast("Something went wrong check your internet connection.")

    });
  }
  categoryClicked(category){
    this.typeChange();
    this.selectedCategory = category.name;
    this.category = category;
    this.get_services();
  }
  typeChange() {
    console.log('OnChange', this.book_time);
    this.service = '';
    this.services = [];
    this.serviceTemp = true;
    this.clear(); 
  }
  clickTime(time){
    this.totalValue();
    this.timing = time;
    this.timeTemp = false;
    this.my_gift_cards();
    this.giftAmount();
    this.paymentTemp = true;
    this.ccFeeCalculate()
  }
  my_gift_cards() {
    let response = this.server.my_gift_cards();
    response.subscribe(data => {
      console.log('my gifts purchased    ',data);
        this.mygifts = data;
    }, error => {
        this.globals.presentToast("Something went wrong check your internet connection.")
  
    });
  }
  giftAmount(){
    if(this.gitfcardAmount){
      if(Number(this.gitfcardAmount) > Number(this.total)){
        this.total = 0;
      }else{
        this.total = Number(this.total) - Number(this.gitfcardAmount);
      }
      }
  }
  totalValue(){
    this.total = 0;
    if(!this.tax){
      var tax = Number(this.globals.tax) / 100 * Number(this.service.price);
      this.tax = tax.toFixed(2);
      }
    this.total =  Number(this.tax) +  Number(this.service.price) +  Number(this.tip);
    if (this.total != 0) {
        this.total = Number(this.total).toFixed(2);
    } 
    console.log("total",this.total)
  }
  clear(){
    this.stylist = '';
    this.timing = '';
    this.stylist_list = [];
    this.schedule_time = '';
    this.date = '';
    this.timings = [];
    this.schedule_time = this.formatDate();
    this.stylistTemp = false;
    this.timeTemp = false;
    this.paymentTemp = false;
    this.tax = 0;
    this.total = 0;
    this.tip = 0;
    this.giftCard = '';
    this.giftcardId = '';
    this.gitfcardAmount = 0;
    this.ccFee = 0;
  }
  clickService(service){
    this.clear();
    this.service = service;
    this.setService();
    this.serviceTemp = false;
    this.stylistTemp = true;
    this.total = this.service.price;
  }
  setService() {
  
    this.globals.presentToast('Please wait...')
    let response = this.server.get_stylist(this.service.id);
    response.subscribe(data => {
      // this.globals.presentToast('Please wait...')
      console.log('stylists ',data)
      if (data.status == true) {
        this.stylist_list = data.stylist;
        this.stylistsModal()
      }
  

    }, error => {
     
      this.globals.presentToast("Something went wrong check your internet connection.")

    });
  }
  async stylistsModal() {
    const modal = await this.modalController.create({
    component: StylistsPage,
    cssClass:'stylistModal',
    mode:'ios',
    swipeToClose:true,
    componentProps: {data: this.stylist_list},
    });
  
    await modal.present();
    modal.onDidDismiss().then(data=>{
console.log('stylist modal returns ',data)
if(data.data){

  this.stylist=data.data.stylist;
  this.showCalender=true;
 
  // this.schedule_time=data.data.date;

  console.log('selected stylist ', this.stylist);
  this.setStylist();
  this.timeTemp = true;
}
    })
  
  }
  setStylist() {
    console.log("Schedule ", this.schedule_time);
    this.globals.presentToast('Please wait...')
  
    
    let response = this.server.get_slots(this.service.id, this.stylist.stylist_id, this.schedule_time);
    response.subscribe(data => {
      this.showTimings=true;
      console.log('stylist slots ',data)
      if (data.status == true) {
        this.timings = data.slots;
      } else {
        this.timings = [];
        this.globals.presentToast(data.message)
      }
  

    }, error => {
 
      this.globals.presentToast("Something went wrong check your internet connection.")
    });
  }
  ccFeeCalculate(){
    console.log(this.globals.cash_discount_percentage)
    this.ccFee =  ((Number(this.globals.cash_discount_percentage) / 100) * Number(this.total)).toFixed(2);
    console.log(this.ccFee)
    this.ccFee = (Number(this.ccFee) + Number(this.globals.cash_discount_value));
    console.log(this.ccFee)
    this.ccFee = this.ccFee.toFixed(2);
    this.subTotal = (Number(this.total) +  Number(this.ccFee)).toFixed(2);
    this.total = this.subTotal;
    console.log(this.subTotal)
  }
  async book() {
    if (this.globals.guess_login) {
      this.presentConfirm();
  } else {
    this.globals.disableBtn('booking')
     this.amountArray = {
    'tip':this.tip,
    'giftcard_amount': this.gitfcardAmount,
    'giftcard_id': this.giftcardId,
    'tax': this.tax,
    'total_amount' : this.total,
    'cc_fee' : this.ccFee
  };
    this.payment();
    var paymentArray = btoa(JSON.stringify(this.paymentDetail));
    var paymentCheck;

    if(this.total > 0){
      if(this.cardNumber && this.cvv && this.expiryMonth && this.expiryYear){
        paymentCheck = true;
      }else{
        paymentCheck = false;
      }
    }else{
      paymentCheck = true;
    }

    if (this.service != '' && this.stylist != '' && this.timing != '' && paymentCheck) {
      let loading =await  this.loadingCtrl.create({
        message: "Loading...",
      });
      loading.present();

      let response = this.server.booking_salon(this.service.id, this.stylist.stylist_id, this.timing.time_slot,paymentArray,this.amountArray,this.notes);
      response.subscribe(data => {
        console.log(data)
        this.globals.presentToast(data.message);
        if (data.status == true) {
          // this.navCtrl.pop();
          this.modalController.dismiss()
        }
        loading.dismiss();

      }, error => {
        loading.dismiss();
        this.globals.presentToast("Something went wrong check your internet connection.")
      });
    } else {
      this.globals.presentToast("Data is not complete to process.")
    }
  }
}
payment(){
  this.paymentDetail = {
    'card_number':this.cardNumber,
    'card_month': this.expiryMonth,
    'card_year': this.expiryYear,
    'card_cvc' : this.cvv,
    'amount' : this.service.price
  };
  console.log(this.paymentDetail)
}
percent_tip(tip) {
  this.tip_type = 'percent';
  this.percent_tip_vlaue = tip;
  if (tip) {
      this.total = Number(this.total) - Number(this.tip);
      this.total = this.service.price;
      this.tip = ((Number(this.total) / 100) * tip).toFixed(2);
      this.total = (Number(this.total) + Number(this.tip)).toFixed(2);
      this.taxValue();
      this.giftAmount();
      this.ccFeeCalculate();
  }
}
  async customTip() {
  this.tip_type = 'manual';

  let alert = await this.alertCtrl.create({
      header: 'Add Gratuity',
      inputs: [
          {
              name: 'tip',
              placeholder: 'Tip',
              type: 'number',
              value: this.tip
          }
      ],
      buttons: [
          {
              text: 'Cancel',
              role: 'cancel',
              handler: data => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'OK',
              handler: data => {
                  data.tip = Math.abs(Number(data.tip));
                  console.log("Tip here >>> ", data);
                  if (data.tip == '') {
                      this.tip = 0;
                  }   
                      this.total = this.total - Number(this.tip);
                      this.total = this.service.price;
                      this.tip = data.tip;
                      this.total = (Number(this.total) + Number(this.tip)).toFixed(2);
                      this.taxValue();
                      this.giftAmount();
                      this.ccFeeCalculate();
                      
                  
              }
          }
      ]
  });
  alert.present();
}
switchback(){
  this.paymentTemp=false;
}
selectedGift(e){
  console.log(e);
}
  async gift_alert() {
  

// let alert=await this.alertCtrl.create()
//   this.mygifts.forEach(e => {
//       alert.inputs({
//           type: 'radio',
//           label: '$' + e.amount,
//           value: e,
//       });
//       alert.buttons['cancel']

  // alert.setHeader('Select Giftcard');

  // this.mygifts.forEach(e => {
  //     alert.addInput({
  //         type: 'radio',
  //         label: '$' + e.amount,
  //         value: e,
  //     });

  // });

  // alert.addButton('Cancel');
  // alert.addButton({
  //     text: 'OK',
  //     handler: data => {
  //         if (data) {
  //                 this.giftCard = data.amount;
  //                 this.giftcardId = data.giftcard_id;
  //                 console.log(this.giftCard, data)
  //                 this.giftcardoption(data);
  //         }


  //     }

}
  async giftcardoption(data_gift) {
  let alert = await this.alertCtrl.create({
    header: 'Payment Type',
      buttons: [
          {
              text: 'Want to add full price for booking',
              cssClass : "alert",
              handler: data => {
               this.fullPayment(data_gift);
              }
          },
          {
            text: 'Want to add partial price for booking',
            handler: data => {
              this.partial_redeem(data_gift)
            }
        }
      ]
  });
  alert.present();
}
giftDetail(g){
  console.log(g)
}
fullPayment(data){
  this.totalValue();
  this.ccFeeCalculate();
  if (Number(data.amount) < Number(this.total)) {
    this.total = (Number(this.total) - Number(data.amount)).toFixed(2);
    this.gitfcardAmount = Number(data.amount).toFixed(2);
}
  else if (Number(data.amount) > Number(this.total)) {
    this.gitfcardAmount = this.total;
    this.total = 0;
    }
    console.log(this.gitfcardAmount)
}
  async partial_redeem(data_gift) {
  let alert = await this.alertCtrl.create({
      header: 'Enter amount you want to pay from giftcard.',
      inputs: [
          {
              name: 'amount',
              placeholder: 'Amount'
          }
      ],
      buttons: [
          {
              text: 'Cancel',
              role: 'cancel',
              handler: data => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Pay',
              handler: data => {
                  this.totalValue();
                  this.ccFeeCalculate();      
                  if (Number(data_gift.amount) < Number(data.amount)) {
                      this.globals.presentToast("You enter amount greater than your giftcard")
                  }
                  else {
                      if (Number(data.amount) > Number(this.total)) {
                        this.gitfcardAmount = this.total;
                        this.total = 0;
                      }
                      else {
                          this.total = (Number(this.total) - Number(data.amount)).toFixed(2);
                          this.gitfcardAmount = Number(data.amount).toFixed(2);
                      }
                  }
              }
          }
      ]
  });
  alert.present();
}
getSavedCards(){
  let tempArray=[]
  let response=localStorage.getItem('paymentmethods')
  tempArray=JSON.parse(response)
  console.log('from local storage',tempArray)
  if(tempArray!=null){
    this.paymentMethods=tempArray;
  }
}
taxValue(){
  if(!this.tax){
    var tax = Number(this.globals.tax) / 100 * Number(this.service.price);
    this.tax = tax.toFixed(2);
    }
  if(this.tax){
    var total = Number(this.tax) + Number(this.total);
    this.total = total.toFixed(2);
    }
   
}
  async presentConfirm() {
  let alert = await this.alertCtrl.create({
      header: 'Login',
      message: 'You need to be logged in to use this feature.',
      buttons: [
          {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Login',
              handler: () => {
                  this.globals.bookingCheck = true;
                  // this.navCtrl.setRoot('LoginPage')
                  this.loginmodal()
              }
          }
      ]
  });
  alert.present();
}
async loginmodal(){
   
  const modal = await this.modalController.create({
  component: LoginModalPage,
  componentProps: { data: {} },
  initialBreakpoint:0.7,
  breakpoints: [ 0.3, 0.5, 0.8],
  backdropDismiss:false,
  cssClass:'loginModal',
  animated: true,
  swipeToClose: false,
  mode: 'ios',
  // handle: false,
  });

  await modal.present();
  modal.onDidDismiss().then(data=>{
    console.log('login modal',data)
  })


}
}
